import React from 'react';
import { TabsContent } from '../../ui/tabs';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../ui/select';
import { Textarea } from '../../ui/textarea';
import { Button } from '../../ui/button';
import { Loader2, ChevronDown, ChevronUp, Image as ImageIcon, Plus } from 'lucide-react';

const ImagenTab = ({
  aiResponse,
  loading,
  content,
  hasText,
  selectedCommand,
  onCommandChange,
  imagenCommands,
  imageDescription,
  onImageDescriptionChange,
  showCustomMessage,
  onToggleCustomMessage,
  message,
  onMessageChange,
  onSend,
  onInsert,
  onResponseChange,
  onResetResponse
}) => (
  <TabsContent value="imagen" className="space-y-3">
    {!aiResponse ? (
      <>
        <div className="space-y-2">
          <label className="text-sm font-medium">Comando de generación</label>
          <Select value={selectedCommand} onValueChange={onCommandChange}>
            <SelectTrigger>
              <SelectValue placeholder="Selecciona un estilo..." />
            </SelectTrigger>
            <SelectContent>
              {imagenCommands.map((cmd) => (
                <SelectItem key={cmd.id} value={cmd.id}>
                  {cmd.title}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <label className="text-sm font-medium">Descripción de la imagen</label>
          <Textarea
            placeholder="Describe la imagen que deseas generar..."
            value={imageDescription}
            onChange={(e) => onImageDescriptionChange(e.target.value)}
            rows={3}
            className="resize-none text-sm"
            disabled={loading}
          />
          {hasText && (
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Texto seleccionado: "{content.text.substring(0, 100)}
              {content.text.length > 100 ? '...' : ''}"
            </p>
          )}
        </div>

        <div className="space-y-2">
          <button
            onClick={onToggleCustomMessage}
            className="flex items-center gap-2 text-sm font-medium hover:text-purple-600 transition-colors"
          >
            {showCustomMessage ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
            Instrucciones adicionales (opcional)
          </button>

          {showCustomMessage && (
            <Textarea
              placeholder="Ej: Hazla en estilo acuarela, con colores suaves..."
              value={message}
              onChange={(e) => onMessageChange(e.target.value)}
              rows={2}
              className="resize-none text-sm"
              disabled={loading}
            />
          )}
        </div>

        <Button
          onClick={onSend}
          disabled={loading || (!imageDescription && !selectedCommand && !content.text)}
          className="w-full bg-gradient-to-r from-purple-500 to-pink-600 hover:from-purple-600 hover:to-pink-700 text-white"
        >
          {loading ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Generando imagen...
            </>
          ) : (
            <>
              <ImageIcon className="w-4 h-4 mr-2" />
              Generar Imagen
            </>
          )}
        </Button>
      </>
    ) : (
      <>
        <div className="space-y-2">
          <label className="text-sm font-medium">Imagen generada</label>
          {aiResponse.startsWith('http') ? (
            <div className="border rounded p-2">
              <img src={aiResponse} alt="Generated" className="w-full rounded" />
            </div>
          ) : (
            <Textarea
              value={aiResponse}
              onChange={(e) => onResponseChange(e.target.value)}
              rows={8}
              className="resize-none text-sm font-mono"
            />
          )}
        </div>

        <div className="flex gap-2">
          <Button
            onClick={onInsert}
            className="flex-1 bg-gradient-to-r from-green-500 to-emerald-600 hover:from-green-600 hover:to-emerald-700 text-white"
          >
            <Plus className="w-4 h-4 mr-2" />
            Insertar en documento
          </Button>
        </div>

        <Button variant="outline" onClick={onResetResponse} className="w-full">
          ← Volver a editar
        </Button>
      </>
    )}
  </TabsContent>
);

export default ImagenTab;
